import { User } from 'models/User';

type TableLabels = Record<keyof User, string>;

type TableLabelsValues =
  typeof PROFILE_TABLE_LABELS[keyof typeof PROFILE_TABLE_LABELS];

export const PROFILE_TABLE_LABELS: Partial<TableLabels> = {
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  contactNumber: 'contactNumber',
  companyName: 'companyName',
  preferredIndustryIncludeMode: 'industriesToInclude',
  preferredIndustryExcludeMode: 'industriesToExclude',
  preferredLocations: 'preferredLocations',
  linkedinAccount: 'linkedinAccount',
} as const;

export const TABLE_KEY_VALUES: Partial<TableLabelsValues>[] = [
  'firstName',
  'lastName',
  'email',
  'contactNumber',
  'linkedinAccount',
  'companyName',
  'preferredIndustries',
  'preferredLocations',
  'preferredBudgets',
];

export const budgetOptions = [
  { value: '<$1m', label: '<$1m' },
  { value: '$1m-$2m', label: '$1m-$2m' },
  { value: '$2m-$5m', label: '$2m-$5m' },
  { value: '$5m-$10m', label: '$5m-$10m' },
  { value: '$10m-$20m', label: '$10m-$20m' },
  { value: '$20m-$30m', label: '$20m-$30m' },
  { value: '>$30m', label: '>$30m' },
];

export const isTableKey = (
  property: keyof User | string,
): property is keyof User =>
  Object.keys(PROFILE_TABLE_LABELS).includes(property);
